/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC40IDguMkgyVjEzSDQuNFY4LjJaTTQuNCA0LjJIMlY2LjY2NjY3SDQuNFY0LjJaTTguNiAxMS42NjY3SDYuMlYxM0g4LjZWMTEuNjY2N1pNNi4yIDEwLjEzMzNIOC42VjJINi4yVjEwLjEzMzNaTTEwLjUzMzMgMTAuMzMzM1YxM0gxMi44VjEwLjMzMzNIMTAuNTMzM1pNMTAuNTMzMyA2LjJWOC44SDEyLjhWNi4ySDEwLjUzMzNaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==";